























import { Component, Vue } from "vue-property-decorator";
import VuePdfApp from "vue-pdf-app";
import { toolbarConfig } from "@/tool/pdfTools";
import loading from "@/components/loader/loading.vue";

@Component({
  components: {
    VuePdfApp,
    loading,
  },
  watch: {
    async $route() {
      this.$data.loading = true;
      this.$data.categoryId = this.$route.query.categoryId;
      this.$data.subCategoryId = this.$route.query.subCategoryId;
      await this.$store.dispatch("handbook/fetchHandbook", {
        categoryId: this.$data.categoryId,
        subCategoryId: this.$data.subCategoryId,
      });
      this.$data.loading = false;
    },
  },
})
export default class Handbook extends Vue {
  categoryId = this.$route.query.categoryId;
  subCategoryId = this.$route.query.subCategoryId;
  loading = false;
  config = toolbarConfig;

  async created() {
    this.loading = true;
    await this.$store.dispatch("handbook/fetchHandbook", {
      categoryId: this.categoryId,
      subCategoryId: this.subCategoryId,
    });
    this.loading = false;
  }

  get handbook() {
    return this.$store.getters["handbook/handbook"];
  }
}
